import MainHome from "@/views/public/MainHome.vue";
import UserLogin from "@/views/auth/UserLogin.vue";
import LaPlatforme from "@/views/public/LaPlatforme.vue";
import NotreApproche from "@/views/public/NotreApproche.vue";
import Contact from "@/views/public/Contact.vue";
import UserRegister from "@/views/auth/UserRegister.vue";
import EmailForgot from "@/views/auth/EmailForgot.vue";
import NewPassword from "@/views/auth/NewPassword.vue";
import CGUPage from "@/components/public/CGUPage.vue";
import ConfPage from "@/components/public/ConfPage.vue";

export const publicRoutes = [
  {
    path: "/",
    name: "Accueil",
    component: MainHome,
    meta: {
      title: "Accueil",
      description:
        "patrimonea by Gwem vous accompagne dans l'analyse, l'organisation et le suivi de votre patrimoine.",
    },
  },
  {
    path: "/acceuil",
    name: "Acceuil",
    component: () => import("@/views/public/Acceuil.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/connexion",
    name: "Connexion",
    component: UserLogin,
    meta: { title: "Connexion", robots: "noindex, nofollow" },
  },
  {
    path: "/platforme",
    name: "La Plateforme",
    component: LaPlatforme,
    meta: {
      title: "La Plateforme",
      description:
        "Decouvrez la plateforme patrimonea by Gwem pour centraliser et piloter votre patrimoine.",
    },
  },
  {
    path: "/approche",
    name: "Notre Approche",
    component: NotreApproche,
    meta: {
      title: "Notre Approche",
      description:
        "Comprenez l'approche patrimonea by Gwem pour analyser, structurer et suivre votre patrimoine.",
    },
  },
  {
    path: "/diagnostic",
    name: "Diagnostic",
    component: () => import("@/views/public/Diagnostic.vue"),
    meta: {
      title: "Diagnostic patrimonial gratuit",
      description:
        "Obtenez en 4 minutes une vision consolidée de votre patrimoine. Gratuit, confidentiel, sans engagement.",
    },
  },
  {
    path: "/diagnostic/offres",
    name: "Diagnostic offres",
    component: () => import("@/views/public/DiagnosticOffersPage.vue"),
    meta: {
      title: "Choisissez votre offre",
      description: "Sélectionnez votre formule Patrimonea et recevez le lien de paiement par email.",
      robots: "noindex, nofollow",
    },
  },
  // {
  //   path: "/diagnostic/resultat",
  //   name: "Diagnostic resultat",
  //   component: () => import("@/views/public/DiagnosticResult.vue"),
  //   meta: {
  //     title: "Résultat de votre diagnostic",
  //     description:
  //       "Consultez votre score de structuration patrimoniale et réservez un échange de 30 minutes.",
  //     robots: "noindex, nofollow",
  //   },
  // },
  {
    path: "/nous-contacter",
    name: "Nous Contacter",
    component: Contact,
    meta: {
      title: "Nous Contacter",
      description:
        "Contactez l'équipe patrimonea by Gwem pour être accompagné dans vos projets patrimoniaux.",
    },
  },
  {
    path: "/inscrire",
    name: "Inscription",
    component: UserRegister,
    meta: { title: "Inscription", robots: "noindex, nofollow" },
  },
  {
    path: "/conditions-generales-utilisation",
    name: "Conditions générales d'utilisation",
    component: CGUPage,
    meta: { title: "Conditions générales d'utilisation", robots: "noindex, nofollow" },
  },
  {
    path: "/politique-de-confidentialite",
    name: "Politique de confidentialité",
    component: ConfPage,
    meta: { title: "Politique de confidentialité", robots: "noindex, nofollow" },
  },
  {
    path: "/mot-de-passe-oublié",
    name: "Mot de passe oublie",
    component: EmailForgot,
    meta: { title: "Mot de passe oublie", robots: "noindex, nofollow" },
  },
  {
    path: "/nouveau-mot-de-passe/:token",
    name: "Nouveau Mot de passe",
    component: NewPassword,
    meta: { title: "Nouveau mot de passe", robots: "noindex, nofollow" },
  },
  /** Retours LKM (URLs par défaut côté backend : FRONTEND_URL + /paiement/succes | /paiement/erreur) */
  {
    path: "/paiement/succes",
    name: "Paiement réussi",
    component: () => import("@/views/patrimoine/payment/PaiementSucces.vue"),
    meta: { title: "Paiement réussi", robots: "noindex, nofollow" },
  },
  {
    path: "/paiement/erreur",
    name: "Erreur de paiement",
    component: () => import("@/views/patrimoine/payment/PaiementErreur.vue"),
    meta: { title: "Erreur de paiement", robots: "noindex, nofollow" },
  },
];
